exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form .col-md-3{width:40%}.table td{padding:5px 10px}.table tr th span.sort.active{color:#ced4da}.right-panel.fHeight{overflow:auto!important}th.scheme-column{padding:22px 70px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2017ba13","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/mutual-funds/rawdata.vue
// module id = 589
// module chunks = 27